import { Container, Image } from 'react-bootstrap'

const LessSixPercent = () => (
    <>
    <div className="section-less-than-6-percent">
        <Container className="text-center">
            <h2>Less than 6% of Doctors get formal training in nutrition.</h2>
            <p>It may shock you to discover that less than 6 percent of <br className="d-none d-xl-block"/>
            graduating physicians receive any formal training in nutrition!</p>
            <p>And few physicians receive training in regard to nutritional supplementation <br className="d-none d-xl-block"/>
            as Dr. Ray Strand experienced during his schooling.</p>
            <Image src="../images/wyd/img-doctors-questions01.png" alt="Less Than 6% Of Doctors" className="img-fluid d-block w-auto mx-auto"/>
        </Container>
    </div>
    <style jsx global>{`

            .section-less-than-6-percent {
                background: #00aec7;
                font-size: 18px;
            }

            .section-less-than-6-percent .container {
                padding-top: 60px;
            }

            .section-less-than-6-percent h2 {
                color: #fff;
                font-size: 40px;
                margin-bottom: 45px;
            }

            .section-less-than-6-percent p {
                margin-bottom: 40px;
                line-height: 36px;
            }

            @media (max-width: 767.98px) {	

                .section-less-than-6-percent .container {
                    padding-top: 30px;
                }

                .section-less-than-6-percent h2 {
                    font-size: 32px;
                    margin-bottom: 25px;
                }

            }

        `}</style>
    </>
);

export default LessSixPercent;